import { useEffect } from "react";
import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";

import useNTRegistrationData from "../../../state/nationalTeamRegistration/UseNTRegistrationData";
import useNTRegistrationLeftNavData from "../../../state/nationalTeamRegistration/nationalTeamRegistrationLeftNav/UseNTRegistrationLeftNavData";
import useNTRegistrationPersonData from "../../../state/nationalTeamRegistration/nationalTeamRegistrationPerson/UseNTRegistrationPersonData";

import useNavRoutes from "@usas/ui-web/state/security/UseNavRoutes";

import { LEFT_NAV_ITEM_NAME_FREQUENT_FLYER } from "../utils/NTRegistrationConstants";

const useNTRegistrationFrequentFlyer = () => {
  const navigate = useNavigate();
  const { navRoutes } = useNavRoutes();
  const { pageHasUnsavedChanges, updatePageHasUnsavedChanges, onNTRegistrationError, onNavigateWithoutSaving
  } = useNTRegistrationData();
  const { updateCurrentLeftNavData } = useNTRegistrationLeftNavData();
  const { nationalTeamRegistrationPersonState, getNTRegistrationPerson, putNTRegistrationPerson } = useNTRegistrationPersonData()

  const onContinueClicked = (event) => {
    try {
      event?.preventDefault();

      if (pageHasUnsavedChanges === true) {
        onNavigateWithoutSaving(navRoutes.NT_REGISTRATION_APPAREL?.route);
      } else {
        navigate(navRoutes.NT_REGISTRATION_APPAREL?.route);
      }
    } catch (e) {
      onNTRegistrationError(e);
    }
  };

  const onBackClicked = (event) => {
    try {
      event?.preventDefault();

      if (pageHasUnsavedChanges === true) {
        onNavigateWithoutSaving(navRoutes.NT_REGISTRATION_SUPPORT_STAFF?.route);
      } else {
        navigate(navRoutes.NT_REGISTRATION_SUPPORT_STAFF?.route);
      }
    } catch (e) {
      onNTRegistrationError(e);
    }
  };

  const onSubmitFrequentFlyerForm = async (frequentFlyerDetails) => {
    try {
      const personId = nationalTeamRegistrationPersonState.objData.personId;
      const newPersonNTObj = JSON.parse(JSON.stringify(nationalTeamRegistrationPersonState.objData));
      newPersonNTObj.frequentFlyerDetails = frequentFlyerDetails;

      await putNTRegistrationPerson(personId, newPersonNTObj);
    } catch (e) {
      onNTRegistrationError(e);
    }
  };

  useEffect(() => {
    async function loadNTRegistrationPerson() {
      try {
        updateCurrentLeftNavData(LEFT_NAV_ITEM_NAME_FREQUENT_FLYER, true);

        if (nationalTeamRegistrationPersonState.isObjLoaded !== true) {
          await getNTRegistrationPerson(0);
        }
      } catch (e) {
        onNTRegistrationError(e);
      }
    }
    loadNTRegistrationPerson();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nationalTeamRegistrationPersonState.isObjLoaded]);

  return {
    isLoading: nationalTeamRegistrationPersonState.isObjLoading,
    personId: nationalTeamRegistrationPersonState.objData?.personId,
    gridData: nationalTeamRegistrationPersonState.objData?.frequentFlyerDetails || [],
    onSubmitFrequentFlyerForm,
    onContinueClicked,
    onBackClicked,
    onNTRegistrationError,
    updatePageHasUnsavedChanges
  };
};

export default useNTRegistrationFrequentFlyer;